import React, { Fragment } from 'react';
import Navbar from "../components/Navbar";
import Sidebar from '../components/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';


export default function Layout({ children }) {
    return (
        <Fragment> 
            <div className="d-flex vh-100">
                <div className="sidebar p-3">
                    <Sidebar />
                </div>
                <div className="flex-grow-1 d-flex flex-column">
                    <Navbar />
                    <div className="container-lg p-4">
                        {children}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
